import { useSavePreference, useReadPreference } from "hooks/preferences"
import {
  DEFAULT_THEME_PREFERENCE,
  THEME_PREFERENCE_KEY,
  THEME_PREFERENCE_TYPE,
  VALID_THEME_PREFERENCES,
} from "../../styles/theme-mode-config"

function toValidPreference(value) {
  if (!value) return null
  return VALID_THEME_PREFERENCES.includes(value) ? value : null
}

export function useThemePreference() {
  const savePreference = useSavePreference(THEME_PREFERENCE_KEY, THEME_PREFERENCE_TYPE)
  const [storedMode, status] = useReadPreference(
    THEME_PREFERENCE_KEY,
    THEME_PREFERENCE_TYPE,
    DEFAULT_THEME_PREFERENCE,
  )

  const validStoredMode = toValidPreference(storedMode)

  return {
    storedMode: validStoredMode,
    preferenceStatus: status,
    saveThemeMode: savePreference,
  }
}
